import styled from 'styled-components'
import Loader from "loaders/Loader";
import { React, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { setDirectoryImagePreview, removeDirectoryImage, chooseDirectoryImage } from '../../features/modal/directoryModalSlice'
import { updateDirectoryItem,addFamilyMemberToSettingsUpdate, discardChanges, editFamilyMemberSettingsUpdate, removePersonFromEditingDirectory } from '../../features/directory/directorySlice'
import LoaderSmall from '../../loaders/HorizontalLoader'
import { imgUrl } from 'features/constants'
import PeopleIcon from '@mui/icons-material/People';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { UploadImageButton } from './settings.styled'
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useTranslation } from 'react-i18next'

function MyDirectoryItem(props) {
    const { t } = useTranslation(['settings', 'common'])
    const dispatch = useDispatch()
    const members = useRef() 
    const [ viewAddUserForm, setViewAddUserForm ] = useState(false)
    const [isChanged, setIsChanged] = useState(false) 
    const { myDirectory, isDirectorySuccess, isDirectoryLoading } = useSelector((state) => state.directory)
    const { directoryImagePreview, selectedImage } = useSelector((state) => state.directoryModal)
    const [ removePersons, setRemovePersons ] = useState(false)
    const [ directoryHeading, setDirectoryHeading ] = useState(myDirectory.name)
    const { isDirectoryUpdatedLoading } = useSelector((state) => state.directory)
    const [ isEditing, setIsEditing ] = useState(false)
    const [emailValid, setEmailValid] = useState(true)
    const [ editingIndex, setEditingIndex ] = useState(-1)

    const handleDiscardChanges = () => {
      dispatch(discardChanges())
      setDirectoryHeading(myDirectory.name)
      dispatch(removeDirectoryImage())
      setIsChanged(false)
    }

    const handleAddDirectoryHeading = (e) => { 
      setDirectoryHeading(e.target.value) 
      if(!isChanged){setIsChanged(true)}
    }

    const handleImageChange = (e) => {

      // ensure that the file is an image and not a webm or mp4
      let fileName = e.target.files[0].name
      let fileType =  fileName.slice(fileName.lastIndexOf('.')+1).toLowerCase()
      if(fileType !== 'jpeg' && fileType !== 'jpg' && fileType !== 'png'){

        return toast.error(t('settings:directoryItem.errors.imageType'))
      }

      if(!isChanged){setIsChanged(true)}
      let url = URL.createObjectURL(e.target.files[0])
      dispatch(setDirectoryImagePreview({ url: url }))
      dispatch(chooseDirectoryImage(e.target.files[0]))
    }

    const addMember = (action) => {
      if(action === 'cancel'){
        setUserInfo(I_STATE)
        setViewAddUserForm(false)
      }else{
        if(!addName){ return toast.error(t('settings:directoryItem.errors.nameRequired')) }
        if(myDirectory.familyList.length < 13){
  
        dispatch(addFamilyMemberToSettingsUpdate({ 
          familyData: JSON.stringify({
            name: addName,
            email: addEmail,
            phone: addPhone,
            about: addAbout,
          })  
        }))

        // setFamilyMembersArray( array => [...array, JSON.stringify(userInfo) ] )
        setUserInfo(I_STATE)
        setViewAddUserForm(false)
        if(!isChanged){setIsChanged(true)}
              
        }else{toast.error(t('settings:directoryItem.errors.memberLimit'))}
      }
    }

    const handleEdit = (action) => {
      if(action === 'cancel'){
        setIsEditing(false)
        setEditingIndex(-1)
        setUserInfo(I_STATE)
        return;
      }
      if(!memberData.name){  return toast.error(t('settings:directoryItem.errors.nameRequired'))}

      dispatch(editFamilyMemberSettingsUpdate({ 
        index: editingIndex,
        familyData: JSON.stringify({
          name: memberData.name,
          email: memberData.email,
          phone: memberData.phone,
          about: memberData.about,
        })  
      }))
      if(!isChanged){setIsChanged(true)}
      setIsEditing(false)
      setEditingIndex(-1)
      setUserInfo(I_STATE)
    }

    //const handleMemberKeyPress = (e) => {if(members.current && (e.key === 'Enter' || e.key === ' ') && familyMember.length > 1) {addMember()}} 
    // const handleEmailChange = (e) => {
    //     if(!isChanged){setIsChanged(true)}
    //     let emailSanitize = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     setEmail(e.target.value)
    //     if (emailSanitize.test(e.target.value)) { setEmailValid(true) }
    //     else { setEmailValid(false) }
    // }
    // const handlePhoneKey = (e) => { if (e.key === 'Backspace' && phone.length === 1) { setPhone('') } }

    const [ memberData, setMemberData ] = useState(null)

    const editMember = (memberData, index) => {  
      if(removePersons){
        dispatch(removePersonFromEditingDirectory({ index: index }))
        setRemovePersons(false)
        if(!isChanged){setIsChanged(true)}
        return;
      }else{
        setIsEditing(true)
        setMemberData(memberData) 
        setEditingIndex(index)        
      }
    }

    const I_STATE = {
      addName: '',
      addEmail: '',
      addPhone: '',
      addAbout: '',
    }

    const [userInfo, setUserInfo] = useState(I_STATE) 
    const { addName, addEmail, addPhone, addAbout } = userInfo

    const handleName = (e) => {
      //if(!isChanged){setIsChanged(true)} 
      if(isEditing){  setMemberData( (prevState) => ( {  ...prevState, name: e.target.value } ) )  }
      else{  setUserInfo((prevState) => ( { ...prevState, [e.target.name]: e.target.value } ) )    } 
    }

    const handleEmail = (e) => {
      let emailSanitize = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(isEditing){  setMemberData(  (prevState) => ( { ...prevState, email: e.target.value } ) )   }
      else{ setUserInfo((prevState) => (  { ...prevState, [e.target.name]: e.target.value  } ) ) }
      if ( emailSanitize.test(e.target.value) ) {setEmailValid(true)}
      else {setEmailValid(false)}
    }

    const handlePhone = (e) => {
      if(isEditing){ setMemberData((prevState) => ({ ...prevState, phone: e.target.value }))  }
      else{ setUserInfo((prevState) => ( { ...prevState, [e.target.name]: e.target.value } ) ) }
    }
    
    const handleAbout = (e) => {
      if(isEditing){ setMemberData( (prevState) => (  {  ...prevState,  about: e.target.value } )  )  }
      else{ setUserInfo((prevState) => ( {  ...prevState,  [e.target.name]: e.target.value  } ) ) }
    }

    const handleSubmit = () => {
      if(!isChanged){return toast.error(t('settings:directoryItem.errors.noChanges'))}
      if (!directoryHeading) { return toast.error(t('settings:directoryItem.errors.nameRequired')) }
      const formData = new FormData();

      formData.append("file", selectedImage)
      formData.append("isImageUpdated", isImgPreview)
      formData.append("familyName", directoryHeading);
      formData.append("oldImage", myDirectory.image ? myDirectory.image.imagePath :  'defaul.jpg')
      // formData.append("churchId", profile._id)

      myDirectory.familyList.map(
          ele => formData.append("familyList", ele)
      )

      dispatch(updateDirectoryItem(formData))
    }

    const isImgPreview = Object.keys(directoryImagePreview).length > 0 

    return (
        <MyDirectoryItemWrap>
            <HeaderSection>
                <div>
                    <PageTitle>{t('settings:directoryItem.title')}</PageTitle>
                    <PageSubtitle>{t('settings:directoryItem.subtitle')}</PageSubtitle>
                </div>
                <MemberCount>{t('settings:directoryItem.memberCount', { count: myDirectory.familyList.length })}</MemberCount>
            </HeaderSection>

            { isDirectoryLoading && ( <Loader /> )  }
 
            { isDirectorySuccess ? (
                <>
                    <DirectoryGrid>
                        <DirectoryCard>
                            <CardHeader>
                                <CardTitle>{t('settings:directoryItem.details')}</CardTitle>
                                <CardCopy>{t('settings:directoryItem.detailsHelp')}</CardCopy>
                            </CardHeader>

                            <InputWrapHeading> 
                                <FieldLabel>{t('settings:directoryItem.heading')}</FieldLabel>
                                <InputWrap hasInput={directoryHeading}>  
                                    <input ref={members} name='name' value={directoryHeading} onChange={handleAddDirectoryHeading} maxLength="25" placeholder={t('settings:directoryItem.namePlaceholder')}/>
                                </InputWrap>  
                            </InputWrapHeading>

                            <ImagePlaceholder>
                                <ImgPreview
                                    src={isImgPreview ? directoryImagePreview.url : myDirectory.image.url}
                                    alt="Directory"
                                />
                            </ImagePlaceholder>
                            <AddImageBtnsWrap>
                                <UploadImageButton 
                                    width='150px'
                                    htmlFor="imageUpload"> 
                                    <RestartAltIcon />
                                    {isImgPreview ? (<span>{t('settings:directoryItem.replaceImage')}</span>) : (<span>{t('settings:directoryItem.uploadImage')}</span>)}
                                </UploadImageButton>
                                <input hidden id="imageUpload" type="file" accept=".png, .jpg, .jpeg" name="file" onChange={handleImageChange} />

                                {isImgPreview && (
                                    <RemoveImage onClick={() => dispatch(removeDirectoryImage())}>
                                        {t('settings:directoryItem.removeImage')}
                                    </RemoveImage>
                                )}
                            </AddImageBtnsWrap>
                        </DirectoryCard>

                        <DirectoryCard>
                            <CardHeader>
                                <CardTitleRow>
                                    <PeopleIcon />
                                    <CardTitle>{t('settings:directoryItem.familyMembers')}</CardTitle>
                                </CardTitleRow>
                                <CardCopy>
                                    {removePersons ? t('settings:directoryItem.removeHelp') : t('settings:directoryItem.editHelp')}
                                </CardCopy>
                            </CardHeader>

                            <InfoItem>
                                { myDirectory.familyList.map((ele, index) => {
                                    let dirData = JSON.parse(ele) 
                                    let name = dirData.name || t('settings:directoryItem.unnamed')

                                    return( 
                                        <FamilyList removing={removePersons} key={`${dirData.phone}-${index}`} onClick={() => editMember(dirData, index)}>
                                            {name}
                                        </FamilyList>
                                    ) 
                                })}
                            </InfoItem>

                            { !isEditing && !viewAddUserForm && (
                                <PersonsButtonWrap>
                                    {removePersons ? (
                                        <SecondaryButton onClick={() => setRemovePersons(false)}>
                                            {t('settings:directoryItem.cancelRemove')}
                                        </SecondaryButton>
                                    ) : (
                                        <>
                                            <ActionButton onClick={() => setViewAddUserForm(true)}>
                                                <PersonAddAlt1Icon />
                                                <span>{t('settings:directoryItem.addPerson')}</span>
                                            </ActionButton>

                                            <DangerButton onClick={() => setRemovePersons(true)}>
                                                <PersonRemoveIcon />
                                                <span>{t('settings:directoryItem.removePerson')}</span>
                                            </DangerButton>
                                        </>
                                    )}
                                </PersonsButtonWrap>
                            )}

                            { viewAddUserForm && !isEditing ?
                                (
                                    <AddUserInputWrap>
                                        <AddUserInputHeading>{t('settings:directoryItem.addPersonTitle')}</AddUserInputHeading>
                                        <InputWrap hasInput={addName}>  
                                            {addName.length > 0 && (<IconInput>{t('settings:directoryItem.name')}</IconInput>)}
                                            <input ref={members} name='addName' value={addName} onChange={handleName} maxLength="25" placeholder={t('settings:directoryItem.fullName')}/>
                                        </InputWrap>
                                        <InputWrap hasInput={addEmail}>  
                                            {addEmail.length > 0 && (<IconInput>{t('settings:account.emailAddress')}</IconInput>)}
                                            <input ref={members} name='addEmail' value={addEmail} onChange={handleEmail} maxLength="25" placeholder={t('settings:directoryItem.email')}/>
                                        </InputWrap>
                                        <InputWrap hasInput={addPhone}>  
                                            {addPhone.length > 0 && (<IconInput>{t('settings:directoryItem.phone')}</IconInput>)}
                                            <input ref={members} name='addPhone' value={addPhone} onChange={handlePhone} maxLength="10" placeholder={t('settings:directoryItem.phone')}/>
                                        </InputWrap>
                                        <InputWrap hasInput={addAbout}>  
                                            {addAbout.length > 0 && (<IconInput>{t('settings:directoryItem.about')}</IconInput>)}
                                            <textarea ref={members} name='addAbout' value={addAbout} onChange={handleAbout} maxLength="1200" placeholder={t('settings:directoryItem.aboutPlaceholder')}/>
                                        </InputWrap>
                                        <AddUserBtnWrap>
                                            <AddUserBtn onClick={addMember}>{t('settings:directoryItem.addPerson')}</AddUserBtn>
                                            <SecondaryButton onClick={() => addMember('cancel')}>{t('common:cancel')}</SecondaryButton>
                                        </AddUserBtnWrap> 
                                    </AddUserInputWrap>
                                )
                                : isEditing && (
                                    <AddUserInputWrap>
                                        <AddUserInputHeading>{t('settings:directoryItem.editingPerson')}</AddUserInputHeading>
                                        <InputWrap hasInput={memberData.name}>  
                                            {memberData.name.length > 0 && (<IconInput>{t('settings:directoryItem.name')}</IconInput>)}
                                            <input ref={members} name='addName' value={memberData.name} onChange={handleName} maxLength="25" placeholder={t('settings:directoryItem.fullName')}/>
                                        </InputWrap>
                                        <InputWrap hasInput={memberData.email}>  
                                            {memberData.email.length > 0 && (<IconInput>{t('settings:account.emailAddress')}</IconInput>)}
                                            <input ref={members} name='addEmail' value={memberData.email} onChange={handleEmail} maxLength="25" placeholder={t('settings:directoryItem.email')}/>
                                        </InputWrap>
                                        <InputWrap hasInput={memberData.phone}>  
                                            {memberData.phone.length > 0 && (<IconInput>{t('settings:directoryItem.phone')}</IconInput>)}
                                            <input ref={members} name='addPhone' value={memberData.phone} onChange={handlePhone} maxLength="10" placeholder={t('settings:directoryItem.phone')}/>
                                        </InputWrap>
                                        <InputWrap hasInput={memberData.about}>  
                                            {memberData.about.length > 0 && (<IconInput>{t('settings:directoryItem.about')}</IconInput>)}
                                            <textarea 
                                                ref={members}  
                                                name='addAbout' 
                                                value={memberData.about} 
                                                onChange={handleAbout}  
                                                maxLength="1200"  
                                                placeholder={t('settings:directoryItem.aboutPlaceholder')}/>
                                        </InputWrap>
                                        <AddUserBtnWrap>
                                            <AddUserBtn onClick={handleEdit}>{t('settings:directoryItem.saveEdit')}</AddUserBtn>
                                            <SecondaryButton onClick={() => handleEdit('cancel')}>{t('common:cancel')}</SecondaryButton>
                                        </AddUserBtnWrap> 
                                    </AddUserInputWrap>
                                )
                            }
                        </DirectoryCard>
                    </DirectoryGrid>

                    { isChanged && (
                        <SubmitButtonWrap> 
                            { isDirectoryUpdatedLoading ? (
                                <SubmitWrap>
                                    <SaveBtn disabled={isDirectoryUpdatedLoading}>{t('settings:directoryItem.saving')}</SaveBtn>
                                    <LoaderSmall />
                                </SubmitWrap>
                                ) 
                                :
                                ( 
                                <SubmitWrap> 
                                    <SaveBtn onClick={handleSubmit}>{t('settings:directoryItem.saveChanges')}</SaveBtn>
                                    <DiscardBtn onClick={handleDiscardChanges}>{t('settings:directoryItem.discardChanges')}</DiscardBtn>
                                </SubmitWrap> 
                                )
                            } 
                        </SubmitButtonWrap>
                    )}
                </>
                )
                :
                ( <div>{t('common:loading')}</div> )
            } 
        </MyDirectoryItemWrap>
    )
}

const MyDirectoryItemWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    color: var(--lightThemeFontColor);
    overflow-y: auto;
    padding: 20px;
    gap: 18px;
    @media (max-width: 768px) {
      padding: 12px;
    }
`

const HeaderSection = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
`

const PageTitle = styled.h1`
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: var(--lightThemeFontColor);
`

const PageSubtitle = styled.p`
    margin: 8px 0 0;
    max-width: 560px;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    line-height: 1.45;
    color: var(--dFontColor);
`

const MemberCount = styled.div`
    min-width: fit-content;
    padding: 7px 12px;
    border-radius: 999px;
    color: var(--themeColor);
    background: rgba(0, 180, 204, 0.1);
    border: 1px solid rgba(0, 180, 204, 0.2);
    font-size: 12px;
    font-family: 'Roboto', sans-serif;
`

const DirectoryGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    gap: 18px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
`

const DirectoryCard = styled.section`
    width: 100%;
    background: #fff;
    border: 1px solid var(--borderColor);
    border-radius: 8px;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);
    padding: 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
`

const CardHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
`

const CardTitleRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
      color: var(--themeColor);
      font-size: 18px;
    }
`

const CardTitle = styled.h2`
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: var(--lightThemeFontColor);
`

const CardCopy = styled.p`
    margin: 0;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    line-height: 1.4;
    color: var(--dFontColor);
`

const InputWrapHeading = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 15px;
  font-size: 14px;
  color: var(--lightThemeFontColor);
  span{
    margin-bottom: 5px;
  }
`

const FieldLabel = styled.span`
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: var(--dFontColor);
`

const InputWrap = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    justify-self: center;
    align-self: flex-start;
    margin-bottom: 5px;
    font-size: 12px;
    transition: all 0.7s;
    border-radius: 6px;

    input{ 
      border: 1px solid var(--borderColor);
      padding: ${props => props.hasInput ? '17px 12px 7px':'0 12px'};
      width: 100%;
      min-height: 42px;
      outline: none;
      border-radius: 6px;
      color: var(--lightThemeFontColor);
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
    }
    input:focus{
      border-color: var(--themeColor);
      box-shadow: 0 0 0 2px rgba(0, 180, 204, 0.12);
      outline: none;
    }
    textarea{
      width: 100%;
      min-height: 130px;
      resize: vertical;
      border: 1px solid var(--borderColor);
      border-radius: 6px;
      color: var(--lightThemeFontColor);
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      padding: ${props => props.hasInput ? '20px 12px 10px':'10px 12px'};
      outline: none;
    }
    textarea:focus{
      border-color: var(--themeColor);
      box-shadow: 0 0 0 2px rgba(0, 180, 204, 0.12);
    }
    textarea::placeholder{
      font-size: 12px;
    }
`

const FamilyList = styled.div`
  padding: 8px 11px;
  background-color: ${props => props.removing ? '#fff5f5' : '#f7f7f7'};
  border: ${props => props.removing ? '1px solid #dc3545':'1px solid var(--borderColor)'};
  color: ${props => props.removing ? '#b42318' : 'var(--lightThemeFontColor)'};
  margin: 0;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
  transition: all 0.2s ease;
  &:hover{
    background-color: ${props => props.removing ? '#ffe8e8' : 'rgba(0, 180, 204, 0.08)'};
    border-color: ${props => props.removing ? '#b42318' : 'var(--themeColor)'};
  }
`

const PersonsButtonWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  flex-wrap: wrap;
`

const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  width: 100%;
  height: fit-content; 
  flex-wrap: wrap;
  gap: 8px;
`


const AddImageBtnsWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`
const RemoveImage = styled.div`
    cursor: pointer;
    font-size: 12px;
    color: rgb(80,80,80);
    &:hover{
      text-decoration: underline;
    }
`

const ImagePlaceholder = styled.div`
    width: 100%;
    height: fit-content;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: 1px solid var(--borderColor);
    background: #f7f7f7;
`

const ImgPreview = styled.img`
    width: 100%;
    height: auto;
    display: block;
`

const ActionButton = styled.button`
    border: 1px solid var(--themeColor);
    background: var(--themeColor);
    color: #fff;
    height: 38px;
    padding: 0 12px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;

    svg {
      font-size: 18px;
    }

    &:hover{
      background: var(--themeColorDark);
      border-color: var(--themeColorDark);
    }
`

const DangerButton = styled(ActionButton)`
    border-color: #dc3545;
    background: #fff;
    color: #b42318;

    &:hover{
      background: #dc3545;
      border-color: #dc3545;
      color: #fff;
    }
`

const SecondaryButton = styled.button`
    border: 1px solid var(--borderColor);
    background: #fff;
    color: var(--lightThemeFontColor);
    height: 38px;
    padding: 0 12px;
    border-radius: 6px;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover{
      border-color: var(--themeColor);
      color: var(--themeColor);
    }
`

const AddUserInputWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: fit-content; 
    width: 100%;
    margin-top: 4px; 
    padding: 14px;
    justify-self: center;
    align-self: center;
    border-radius: 8px;
    border: 1px solid var(--borderColor);
    background: #fbfbfb;
`
const AddUserInputHeading = styled.div`
  width: 100%; 
  margin-bottom: 12px;
  color: var(--lightThemeFontColor);
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
`

const AddUserBtnWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 8px;
`

const AddUserBtn = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 100px;
  height: 38px;
  justify-content: center;
  background-color: var(--themeColor);
  border: 1px solid var(--themeColor);
  font-size: 13px;
  padding: 0 12px;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover{
    background-color: var(--themeColorDark);
    border-color: var(--themeColorDark);
  }
`

const IconInput = styled.div`
    position: absolute;
    color: #a3a3a3;
    top: 4px;
    left: 12px;
    font-size: 11px;
`

const SaveBtn = styled.button`
  pointer-events: ${props => props.disabled ? 'none':'auto'};
  width: fit-content;
  border: 1px solid var(--themeColor);
  background-color: var(--themeColor);
  padding: 10px 18px;
  color: white;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  &:hover{
    cursor:pointer;
    background-color: var(--themeColorDark);
    border-color: var(--themeColorDark);
  }
`
const SubmitButtonWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`

const SubmitWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  height: fit-content;
  background: #fff;
  border: 1px solid var(--borderColor);
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);
`


const DiscardBtn = styled.div`
  padding: 5px 8px;
  color: #912121;
  cursor: pointer;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;

  &:hover{
    text-decoration: underline;
  }
`

export default MyDirectoryItem
